'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _defineProperty2 = require('babel-runtime/helpers/defineProperty');
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _extends3 = require('babel-runtime/helpers/extends');
var _extends4 = _interopRequireDefault(_extends3);
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');
var _dimensionUtils = require('../dimension-utils');
var _observationFormater = require('../observation-formater');
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var flatDatapoints = function flatDatapoints(observations, dimensions, dimensionsWithValuesIndexedById, serieDimensionId, display, formaterAttrs, _ref) {
  var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
    stackKey = _ref2[0],
    categoryKey = _ref2[1];
  var datapoints = R.mapObjIndexed(function (observationValue, observationKey) {
    var _ref3;
    var category = null;
    var value = Number(R.head(observationValue));
    var formater = (0, _observationFormater.getObservationFormater)(observationValue, formaterAttrs);
    var splittedKey = R.split(':', observationKey);
    var layerKey = [];
    var layerDimensions = R.addIndex(R.reduce)(function (memo, dimensionValueIndex, dimensionIndex) {
      var dimension = R.nth(dimensionIndex, dimensions);
      var _dimensionValue = R.pathOr({}, ['values', Number(dimensionValueIndex)], dimension);
      var label = (0, _dimensionUtils.dimensionValueDisplay)(display)(_dimensionValue);
      var dimensionValue = (0, _extends4.default)({}, _dimensionValue, {
        index: Number(dimensionValueIndex),
        label: label
      });
      if (dimension.id === serieDimensionId) {
        category = dimensionValue;
      } else if (R.has(dimension.id, dimensionsWithValuesIndexedById)) {
        memo.push(dimensionValue);
        layerKey.push(dimensionValueIndex);
      }
      return memo;
    }, [], splittedKey);
    return _ref3 = {
      formater: formater
    }, (0, _defineProperty3.default)(_ref3, categoryKey, category), (0, _defineProperty3.default)(_ref3, stackKey, value), (0, _defineProperty3.default)(_ref3, 'layerDimensions', layerDimensions), (0, _defineProperty3.default)(_ref3, 'layerKey', R.join(':', layerKey)), _ref3;
  }, observations);
  return R.values(datapoints);
};
var serie = function serie(observations, dimensions, dimensionsWithValuesIndexedById, singularity, display, formaterAttrs, _ref4) {
  var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
    stackKey = _ref5[0],
    categoryKey = _ref5[1];
  var serieDimensionId = R.propOr(null, 'id', singularity);
  var serieDimension = R.find(R.propEq('id', serieDimensionId), dimensions);
  if (R.isNil(serieDimension)) {
    return {
      datapoints: [],
      layerSeries: []
    };
  }
  var _flatDatapoints = flatDatapoints(observations, dimensions, dimensionsWithValuesIndexedById, serieDimensionId, display, formaterAttrs, [stackKey, categoryKey]);
  var layeredDatapoints = R.groupBy(R.prop('layerKey'), _flatDatapoints); // { [layeredKey]: [dps] }

  var layerFullSeries = R.map(function (datapoints) {
    return {
      layerDimensions: R.prop('layerDimensions', R.head(datapoints)),
      layerKey: R.prop('layerKey', R.head(datapoints))
    };
  }, R.values(layeredDatapoints)); // [{ layerDimensions, layerKey }]

  var layerLimit = R.propOr(Infinity, 'limit', singularity);
  var layerSeries = R.take(layerLimit, R.sortBy(R.prop('layerKey'), layerFullSeries));
  var layeredDatapointsKeyedByCategory = R.mapObjIndexed(R.indexBy(R.path([categoryKey, 'id'])), layeredDatapoints); // { [layeredKey]: { [x.id]: dp } }

  var datapoints = R.addIndex(R.map)(function (serieValue, index) {
    var _ref8;
    var serieValueId = serieValue.id;
    var category = (0, _dimensionUtils.dimensionValueDisplay)(display)(serieValue);
    var values = R.map(function (_ref6) {
      var layerKey = _ref6.layerKey;
      return R.pathOr(null, [layerKey, serieValueId, stackKey], layeredDatapointsKeyedByCategory);
    }, layerSeries);
    var formaters = R.map(function (_ref7) {
      var layerKey = _ref7.layerKey;
      return R.pathOr(null, [layerKey, serieValueId, 'formater'], layeredDatapointsKeyedByCategory);
    }, layerSeries);
    return _ref8 = {
      category: category,
      formaters: formaters,
      index: index
    }, (0, _defineProperty3.default)(_ref8, categoryKey, category), (0, _defineProperty3.default)(_ref8, stackKey, values), (0, _defineProperty3.default)(_ref8, 'key', serieValueId), _ref8;
  }, serieDimension.values);
  var _datapoints = R.when(R.pipe(R.length, R.equals(1)), R.pipe(R.set(R.lensPath([0, 'category']), ''), R.set(R.lensPath([0, categoryKey]), '')), datapoints);
  return {
    datapoints: _datapoints,
    layerSeries: R.map(function (layer) {
      return {
        id: R.pipe(R.prop('layerDimensions'), R.pluck('id'), R.join(' - '))(layer),
        label: R.pipe(R.prop('layerDimensions'), R.pluck('label'), R.join(' - '))(layer)
      };
    }, layerSeries)
  };
};
var percentSerie = function percentSerie(stackKey) {
  return R.pipe(R.over(R.lensProp('datapoints'), R.map(function (dp) {
    var _extends2;
    var total = R.pipe(R.map(function (v) {
      return Math.abs(v);
    }), R.sum)(dp[stackKey]);
    if (!total) {
      return dp;
    }
    return (0, _extends4.default)({}, dp, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, stackKey, R.map(function (v) {
      return Math.abs(v) / total * 100;
    }, dp[stackKey])), (0, _defineProperty3.default)(_extends2, 'formaters', null), _extends2));
  })), R.of);
};
var serieSortedByTotal = function serieSortedByTotal(stackKey) {
  return R.pipe(R.over(R.lensProp('datapoints'), R.sortBy(R.pipe(R.prop(stackKey), R.map(function (v) {
    return v > 0 ? R.negate(v) : 0;
  }), R.sum))), R.of);
};
var serieSortedByDataOrder = R.pipe(R.over(R.lensProp('datapoints'), R.sortBy(R.prop('index'))), R.of);
exports.default = function (_ref9, dimensionsWithValuesIndexedById, singularity, display, formaterAttrs, _ref10) {
  var observations = _ref9.observations,
    dimensions = _ref9.dimensions;
  var _ref11 = (0, _slicedToArray3.default)(_ref10, 2),
    stackKey = _ref11[0],
    categoryKey = _ref11[1];
  var mode = R.propOr('values', 'mode', singularity);
  var serieDimensionId = R.propOr(null, 'id', singularity);
  var _serie = serie(observations, dimensions, dimensionsWithValuesIndexedById, singularity, display, formaterAttrs, [stackKey, categoryKey]);
  if (mode === 'percent') {
    return percentSerie(stackKey)(_serie);
  } else if ((0, _dotstatsuiteSdmxjs.isTimePeriodDimension)({
    id: serieDimensionId
  })) {
    return serieSortedByDataOrder(_serie);
  }
  return serieSortedByTotal(stackKey)(_serie);
};